module.exports = __webpack_public_path__ + "experience/innovation/models/factory-room.a0d717c.obj";


//////////////////
// WEBPACK FOOTER
// ./src/components/app-experience/Experience/models/factory-room.obj
// module id = ijPX
// module chunks = 1